import { Button } from 'base/ui/button';
import { DialogLayer } from 'base/ui/dialog';
import { Icon } from 'base/ui/icon';
import { IconClear, IconFigma, IconReact, IconWebflow } from 'base/ui/icons';
import {
  TextRegularLight,
  TextSmall,
  TextTiny,
  Title5,
} from 'base/ui/typography';
import React from 'react';
import ExportHeroImage from './export-hero.file.webp';
import styles from './export_dialog.css';

type Props = {
  onClose: () => void;
};

export const StyleGuideExportDialog = ({ onClose }: Props) => {
  return (
    <DialogLayer onClose={onClose}>
      <div className={styles.container}>
        <img src={ExportHeroImage} className={styles.heroImage} />
        <div className={styles.content}>
          <div className={styles.header}>
            <TextSmall color="gradient">Coming soon</TextSmall>
            <Title5>Export your Style Guide</Title5>
            <div className={styles.closeButton}>
              <Button
                icon={IconClear}
                size="large"
                variant="tertiary"
                onClick={onClose}
              />
            </div>
          </div>
          <TextRegularLight>
            We wanted you to try our Style Guide Builder ASAP, so export is
            coming in the next update — we know it's essential!
          </TextRegularLight>
          <div className={styles.features}>
            <div className={styles.featureRow}>
              <div className={styles.featureRowIcon}>
                <Icon icon={IconFigma} />
              </div>
              <TextSmall>Export Style Guide - Figma</TextSmall>
              <div className={styles.spacer} />
              <div className={styles.featureRowStatus}>
                <TextTiny>In progress</TextTiny>
              </div>
            </div>
            <div className={styles.featureRow}>
              <div className={styles.featureRowIcon}>
                <Icon icon={IconWebflow} />
              </div>
              <TextSmall>Export Style Guide - Webflow</TextSmall>
              <div className={styles.spacer} />
              <div className={styles.featureRowStatus}>
                <TextTiny>In progress</TextTiny>
              </div>
            </div>
            <div className={styles.featureRow}>
              <div className={styles.featureRowIcon}>
                <Icon icon={IconReact} />
              </div>
              <TextSmall>Export Style Guide - React</TextSmall>
              <div className={styles.spacer} />
              <div className={styles.featureRowStatus}>
                <TextTiny color="grey">Coming soon</TextTiny>
              </div>
            </div>
          </div>
          <div className={styles.spacer} />
          <div className={styles.footer}>
            <Button variant="primary" label="Got it" onClick={onClose} />
          </div>
        </div>
      </div>
    </DialogLayer>
  );
};
